export const LOAN_VALUE_COLUMN = { key: 'loanValue', label: 'Loan Value' };

const WATERFALL_FUND_SUMMARY_BASE_COLUMNS = [
  { key: 'entity', label: 'Entity' },
  { key: 'exitProceeds', label: 'Exit Proceeds' },
];

const WATERFALL_FUND_SUMMARY_TAIL_COLUMNS = [
  { key: 'previousProceeds', label: 'Previous Proceeds' },
  { key: 'investedCapital', label: 'Invested Capital' },
  { key: 'moic', label: 'MOIC' },
  { key: 'irr', label: 'IRR' },
];

export const WATERFALL_FUND_SUMMARY_COLUMNS = [
  ...WATERFALL_FUND_SUMMARY_BASE_COLUMNS,
  ...WATERFALL_FUND_SUMMARY_TAIL_COLUMNS,
];

export const WATERFALL_FUND_SUMMARY_COLUMNS_WITH_LOAN = [
  ...WATERFALL_FUND_SUMMARY_BASE_COLUMNS,
  LOAN_VALUE_COLUMN,
  ...WATERFALL_FUND_SUMMARY_TAIL_COLUMNS,
];
